import { render } from "./PriceSuggestions.vue?vue&type=template&id=617fc3da"
import script from "./PriceSuggestions.vue?vue&type=script&lang=js"
export * from "./PriceSuggestions.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__